module.exports = __webpack_public_path__ + "static/media/rotor-solution-top.a35608c8.svg";